import { AddressDetails } from "../smart-components/smart-component-property";
import { SmartComponentPropertyDetails } from "../smart-components/smart-component-property-details";
import { SkillNameList } from "../../enum/enumSkillNameList";
import { IComponentLoader } from "../../interfaces/IComponentLoader";
import { ComponentAdapterParent } from "./component-adapter-parent";


export class ComponentAdapterRoom extends ComponentAdapterParent implements IComponentLoader {


    constructor() {
        super();
    }

    public fillProperty(listSmartComponentSkills: Array<SmartComponentPropertyDetails>): void {
        this.fillMissingProperty();
        this.fillAddressState();
    }

    public fillMissingProperty(): void {
    }

    public fillAddressState(): void {
    }
}